/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProgramPeriod } from '../../models/program-period';

export interface List$Params {
  programSlug: string;
}

export function list(
  http: HttpClient,
  rootUrl: string,
  params: List$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<ProgramPeriod>>> {
  const rb = new RequestBuilder(rootUrl, list.PATH, 'get');
  if (params) {
    rb.path('programSlug', params.programSlug, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProgramPeriod>>;
    })
  );
}

list.PATH = '/auditing/programs/{programSlug}/periods';
